import React, {useCallback, useRef} from "react";
import s from "./auth-popap.module.scss";
import {ClockIcon2} from "../../../icons/AuthPopupIcons";

export const PhoneConfirmation2 = ({previousTab, phoneConfirmation, number, refreshCode, codeError, setCodeError }) => {
  const [disabled, setDisabled] = React.useState(true)
  const [counter, setCounter] = React.useState(30)

  const [sms, setSms] = React.useState('••••')
  const ref = useRef(null)
  const smsLength = 4

  const timer = useCallback(() => {
    setTimeout(() => {
      setCounter(count => {
        if(count === 0) {
          setDisabled(false)
          return count
        }
        timer()
        return count - 1
      })
    }, 1000)
  }, [setDisabled, setCounter])

  React.useEffect(() => timer(),[timer])

  const sandAgain = () => {
    if (disabled) return
    setCounter(30)
    timer()
    refreshCode()
    setDisabled(true)
  }

  const onChange = (value) => {
    setCodeError(false)
    value = value.replace(/•/g, '')
    if (!Number.isInteger(+value) || value.length > smsLength) return
    if (value.length === smsLength) {
      phoneConfirmation(String(value))
    }
    const dots = '•'.repeat( smsLength - value.length)
    setSms(value + dots)
    setTimeout(() => { ref.current.setSelectionRange(value.length, value.length) }, 0)
  }
  const onKeyDown = (key) => {
    if(key === 'Backspace') {
      setTimeout(() => {
        const value = sms.replace(/•/g, '').slice(0, -1)
        const dots = '•'.repeat( smsLength - value.length)
        setSms(value + dots)
      }, 0)
    }
  }

  return (
    <div className={s.phone2}>
      <div>
        <div className={s.phone_break}>
          <div className={s.title2}>Вы отправили смс-код на номер</div>
          <div className={s.title2}>&nbsp;{number}</div>
        </div>

        <div
          className={s.text} style={{cursor: 'pointer', color: '#FF6938', marginTop: '5px', }}
          onClick={previousTab}
        >
          Изменить
        </div>

        <div style={{display: 'flex', justifyContent: 'center', marginTop: '15px'}}>
          <input
            ref={ref}
            className={s.phone_code}
            style={{borderBottom: (codeError ? '1px solid #FF5D5D' : '')}}
            value={sms}
            type="text"
            onChange={e => onChange(e.target.value)}
            onKeyDown={e => onKeyDown(e.key)}
            autoComplete="one-time-code"
            inputMode='numeric'
            autoCorrect="off"
            autoCapitalize="off"
          />
        </div>
        {codeError && <div className={s.errorMessage} style={{marginTop: '5px'}}>
          Неправильно введен смс-код
        </div>}
      </div>

      <div>
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'center'}}>
          <ClockIcon2/>
          <div className={s.phone_retry}>
            {`Отправить код повторно через 0:${counter > 9 ? counter : `0${counter}` }`}
          </div>
        </div>
        <button
          className={s.disabled_button}
          onClick={sandAgain}
          disabled={disabled}
        >
          Отправить повторно
        </button>
      </div>
    </div>
  )
}
